module.exports = "Navigation components allow the user to navigate through the application."